module.exports = __webpack_public_path__ + "img/169.a579a116.png";